import RemoveEntry from "../components/RemoveEntry";

export default function RemovePage() {
  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <RemoveEntry />
    </div>
  );
}